export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  const wrapContainerClass = 'seo-concept7-container';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomSeo(data.items[0]);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description } = widgetData;
    const $seo = $(`#${widgetName}`).find('.card-widget-item');

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <span class="seo-divider"></span>
      <p class="seo-description">${Description}</p>
    `);
  }
}
